//eslint-disable-next-line
export const websiteRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

//eslint-disable-next-line
export const phoneNumberRegex = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;

export const zipRegex = /^[0-9 -]*$/;

export const objectIdRegex = /^[0-9a-fA-F]{24}$/;

//eslint-disable-next-line
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W\_]{10,}$/;
